
import { defineComponent } from "vue";
import Menu from "@/components/menu.vue"; // @ is an alias to /src
import { mapState } from "vuex";
import api from "@/api";


function makeid(length:any) {
   var result           = '';
   var characters       = 'abcdef0123456789';
   var charactersLength = characters.length;
   for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
   }
   return result;
}

export default defineComponent({
  name: "HomeView",
  components: {
    Menu
  },
  data() {
    return {
      g_link : 'https://buy.stripe.com/fZe3dT5hkdVs8ZqcN4'
    }
  },
  mounted(){


    let k = localStorage.getItem('location_thing')
    if (k == 'Russia'){
      this.$data.g_link = 'https://portret.ai/ru#myprice'
    }

    api.photos().then((data:any)=>{
      this.$store.commit('set_photos', data.data)
    })

  },
  methods: {
    play(){
      // try {
      //   window.logsnag.publish({
      //     channel: "actions",
      //     event: "play",
      //     description: "email: " + this.email + " started source video ",
      //     icon: "🕹",
      //     notify: false,
      //     tags: {
      //       email: this.email,
      //     }
      //   })
      // } catch (e) {

      // }
    },
    onChange(e:any){
      let vm = this;
      let files = e.target.files;
      console.log(files.length);

      // for (let i=0; i<files.length; i++){
      [...files].forEach((file:any) => {

        // let file = files[0]
        console.log(file);

        var re = /(?:\.([^.]+))?$/;
        let allowed = [
          'jpg',
          'jpeg',
          'png',
          'heic'
        ]
        let check_name = file.name.toLowerCase()
        let validate = false;
        allowed.forEach((ex)=>{
          if (check_name.indexOf(ex) != -1){
            validate = true
          }
        })
        if (!validate){
          alert('wrong format - JPG or PNG only')
        }
        var ext = check_name.split('.')[1];
        let new_name = makeid(32) + '.' + ext
        Object.defineProperty(file, 'name', {
          writable: true,
          value : new_name
        });

         vm.$store.dispatch("proxy_file", file);

      })

    //


    //
    //   window.model_neural_network = this.$data.model
    //   this.$store.dispatch("proxy_file", {file, model : this.$data.model});
    },
    start_train(){
      if (this.photos.length > 4){
        api.start_train().then(()=>{
          this.$store.commit('set_status', 'in_progress')
        })
        console.log('start train');
      } else {
        alert('Upload more photos with your face')
      }

    }
  },
  computed: {
    ...mapState({
      email: (state: any) => state.email,
      status: (state: any) => state.status,
      paid: (state: any) => state.paid,
      photos: (state: any) => state.photos
    })
  },
});
